import helper from '../../utils/helper'

// default css classes style
const lastBenefitClass = 'border-bottom border-dark'

/**
 * Handle UI logic quick quote render
 */
const quickQuoteHandler = {
	/**
	 * Draw benefit: checkbox | radio
	 * @param {*} loc - levels of cover
	 * @returns
	 */
	renderBenefits(loc) {
		if (!loc.benefits || !loc.benefits.length) {
			return
		}

		// ignore benefit were checked
		if (loc.benefits.find((v) => 'isRadio' in v)) {
			return
		}

		// get benefit exclusions data if exist
		let groupIdBenefits = null
		const markedBenefits = new Map()
		try {
			groupIdBenefits = helper.groupByField(loc.benefits, 'benefitGroupId')

			// Mark class
			for (const key in groupIdBenefits) {
				if (key && Object.hasOwnProperty.call(groupIdBenefits, key)) {
					const benefits = groupIdBenefits[key]
					// get first and last el need to be mark with border
					if (benefits != null && benefits.length) {
						markedBenefits.set(benefits[benefits.length - 1].benefitName, lastBenefitClass)
					}
				}
			}
		} catch (e) {}

		loc.benefits.forEach((benefit) => {
			// Draw
			if (benefit.benefitGroupId === null || benefit.benefitGroupId.trim() === '') {
				benefit.isRadio = false
			} else {
				benefit.isRadio = true
			}

			// Mark class
			benefit.additionalClass = ''
			if (markedBenefits.get(benefit.benefitName) !== undefined && Object.keys(groupIdBenefits).length >= 2) {
				benefit.additionalClass = markedBenefits.get(benefit.benefitName)
			}
		})
	},

	renderCoInsures(loc) {
		if (!loc.coInsures || !loc.coInsures.length) {
			return
		}

		// get benefit exclusions data if exist
		let groupIdCoInsures = null
		const markedCoInsures = new Map()

		try {
			groupIdCoInsures = helper.groupByField(loc.coInsures, 'CoInsureGroupId')

			// Mark class
			for (const key in groupIdCoInsures) {
				if (key && Object.hasOwnProperty.call(groupIdCoInsures, key)) {
					const coInsures = groupIdCoInsures[key]
					// get first and last el need to be mark with border
					if (coInsures != null && coInsures.length) {
						markedCoInsures.set(coInsures[coInsures.length - 1].coInsureName, lastBenefitClass)
					}
				}
			}
		} catch (e) {}

		loc.coInsures.forEach((coInsure) => {
			coInsure.additionalClass = ''
			if (markedCoInsures.get(coInsure.coInsureName) !== undefined && Object.keys(groupIdCoInsures).length >= 2) {
				coInsure.additionalClass = markedCoInsures.get(coInsure.coInsureName)
			}
		})
	},
}

export default quickQuoteHandler
